<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/parent-corporations/list" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="update" v-if="parentCorp">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                          <div class="col-12" v-if="corps.length">
                            <multiselect
                              v-model="parentCorp.csvCorporationIds"
                              placeholder="Associate Child Corporations"
                              :multiple="true"
                              :taggable="true"
                              :options="corps.map(type => type.corporationId)"
                              :custom-label="opt => corps.find(x => x.corporationId == opt).name">
                              >
                            </multiselect>
                          </div>
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="parentCorp.name"
                                          label="Title"
                                          placeholder="Enter Title"
                                          v-validate="rules.name"
                                          data-vv-name="name"
                                          cus-name="name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="parentCorp.description"
                                      label="Description"
                                      placeholder="Enter Description"
                                      v-validate="rules.description"
                                      data-vv-name="Description"
                                      cus-name="Description"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-12" v-if="corpUsers.length">
                            <label>Select Super Users</label>
                            <multiselect
                              v-model="parentCorp.csvParentSuperUserIds"
                              placeholder="Set Parent Super Users"
                              :multiple="true"
                              :taggable="true"
                              :options="corpUsers.map(type => type.userId)"
                              :custom-label="opt => corpUsers.find(x => x.userId == opt).userNameWithCorpInfo"
                              >
                            </multiselect>
                          </div>
                            <div class="col-md-3" v-if="status.length">
                                <fg-select
                                        v-model="parentCorp.active"
                                        label="Active"
                                        v-validate="rules.active"
                                        data-vv-name="active"
                                        cus-name="active"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any() || (!parentCorp.csvCorporationIds || parentCorp.csvCorporationIds.length === 0)" class="btn btn-primary btn-fill btn-block">
                            Update Parent Corporation
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'EditparentCorp',
        created (){
          let self = this
          this.fetchCorporations();
        this.$store.dispatch('GET_SELECTED_PARENT_CORP', this.$route.params.id).then((res) => {
          let selectedCorporations = self.parentCorp.csvCorporationIds
          self.parentCorp.csvCorporationIds = self.parentCorp.csvCorporationIds.split(',')
          self.parentCorp.csvParentSuperUserIds = self.parentCorp.csvParentSuperUserIds.split(',')
        }).catch(err => {
          }),
          (err) => {
          }
    },
    data () {
        return {
            loaded: false,
            createdCalled: false,
            userIdList:null,
            corpIds: null,
            largeNewImage: [],
            smallNewImage: [],
            parentCorpString: '',
            corps: [],
            corpUsers: [],
//            parentCorp: null,
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            rules: {
              name : {required: true},
              description: {required: true},
              csvCorporationIds: {required: true}
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchCorporationUsers (coprList) {
        this.$store.dispatch('GET_PARENT_CORP_USER_LIST', coprList)
          .then((res) => {
            this.createdCalled = true
            this.corpUsers = res.payload;
            console.log("this.corporations users : ", this.corpUsers);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        update () {
            this.$validator.validateAll().then((result) => {
                if(result){
                    let update = () =>{
                        this.$store.dispatch('UPDATE_PARENT_CORP', this.parentCorp)
                                .then((res) => {
                                    console.log("UPDATE_CORPORATION res : ", res);
                                    this.showPopup('Success!', 'Parent Corporation is successfully updated', 'success', ()=>this.$router.push('/admin/parent-corporations'))
                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                                    console.log("UPDATE_CORPORATION API error : ", err);
                                })
                    };
                    update();
                }
            })
            console.log("this.corporations : ", this.corporations);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        updateLargeImg(data){
            this.corporation.largeImage = data.path;
            this.largeNewImage = data.value;
            console.log("updateLargeImg data : ", data);
        },
        updateSmallImg(data){
            this.corporation.smallImage = data.path;
            this.smallNewImage = data.value;
            console.log("updateSmallImg data : ", data);
        },
    },
      watch: {
          'parentCorp.csvCorporationIds' (to, from) {
            let self = this
            let newUserList = []
            let currentUserList = self.userIdList
            console.log('currentUserList', currentUserList)
            // self.userIdList = []
            if (self.parentCorp.csvCorporationIds && self.parentCorp.csvCorporationIds.length > 0) {
              self.fetchCorporationUsers(self.parentCorp.csvCorporationIds.join(','))
            }
            if (!self.loaded) {
              self.loaded = true
            } else {
              self.parentCorp.csvParentSuperUserIds = []
            }
          }
      },
    computed: {
        ...mapGetters([ 'corporations', 'selectedParentCorp', 'parentCorpUserList']),
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        },
        parentCorp(){
            return this.selectedParentCorp
        }
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ParentCorps/EditParentCorp.vue